import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { apiEnableUser } from '@services/ManageUserOperator/UserOperatorServices';
import { showSuccess, showError } from '@components/notification';

const EnableUserModal = ({ open, onClose, userInfo, onSuccess }) => {
  const [loading, setLoading] = useState(false);

  const handleEnable = async () => {
    try {
      setLoading(true);
      await apiEnableUser(userInfo.id);
      showSuccess({ message: 'Kích hoạt người dùng thành công!' });
      onClose();
      onSuccess();
    } catch (error) {
      showError(error?.message || 'Không thể kích hoạt người dùng');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <span>
          <ExclamationCircleOutlined style={{ color: '#52c41a', marginRight: 8 }} />
          Xác nhận kích hoạt người dùng
        </span>
      }
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Hủy
        </Button>,
        <Button
          key="enable"
          type="primary"
          loading={loading}
          onClick={handleEnable}
          style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}>
          Kích hoạt
        </Button>
      ]}>
      <p>
        Bạn có chắc chắn muốn kích hoạt lại người dùng <strong>{userInfo?.user_name}</strong>?
      </p>
      <p style={{ color: '#666', fontSize: '14px' }}>
        Sau khi kích hoạt, người dùng này sẽ có thể đăng nhập và sử dụng hệ thống.
      </p>
    </Modal>
  );
};

export default EnableUserModal;
